@if (!isMobileScreen()) {
    <div class="flex flex-col">
        <div class="flex flex-row text-sm gap-2 items-center align-middle">
            <div class="flex flex-row grow">
                @for (layer of deck.layers ; track layer.name) {
                    <div (click)="deckComponent.onLayerClick(layer)" class="border border-b-0 border-ponder-light p-2 rounded-t-lg hover:cursor-pointer" [ngClass]="{ 'bg-ponder-light text-slate-50' : deckComponent.isActiveLayer(layer) }">
                        {{ layer.name }} ({{ layer.totalCount }})
                    </div>
                }
            </div>
            @if (deckComponent.isOwnDeck) {
                <deck-card-search [game]="deckComponent.game" [deckComponent]="deckComponent"></deck-card-search>
                <deck-copy [deck]="deck" class="stroke-ponder"></deck-copy>
                <deck-export [deck]="deck" class="stroke-ponder"></deck-export>
                <deck-edit-options [deck]="deck" class="stroke-ponder"></deck-edit-options>
                <deck-delete [deckId]="deck.id!" [deckName]="deck.name!" class="stroke-ponder"></deck-delete>
            } @else if (deckComponent.isAuthed) {
                <deck-copy [deck]="deck" class="stroke-ponder"></deck-copy>
                <deck-export [deck]="deck" class="stroke-ponder"></deck-export>
            }
        </div>
        <deck-value-stats [currentLayer]="currentLayer"></deck-value-stats>
    </div>
} @else {
    <div class="flex flex-col p-2 gap-2 bg-ponder-light">
        <div class="flex flex-row p-2 gap-1 align-middle items-center">
            <select #mobileLayerSelect (change)="deckComponent.onMobileLayerSelect(mobileLayerSelect.value)" class="p-1 bg-ponder-xlight text-slate-50 min-h-8 sm:min-w-30 rounded-sm shadow-sm grow text-xs">
                @for (layer of deck.layers ; track layer.name) {
                    <option value="{{ layer.name }}">{{ layer.name }} ({{ layer.totalCount }})</option>
                }
            </select>
            @if (deckComponent.isOwnDeck) {
                <deck-card-search [game]="deckComponent.game" [deckComponent]="deckComponent"></deck-card-search>
            }
        </div>
        <div class="flex flex-row gap-1 justify-end items-center pl-2 pr-2">
                <deck-value-stats [currentLayer]="currentLayer" class="grow"></deck-value-stats>
            @if (deckComponent.isOwnDeck) {
                <deck-copy [deck]="deck" class="stroke-slate-300"></deck-copy>
                <deck-export [deck]="deck" class="stroke-slate-300"></deck-export>
                <deck-edit-options [deck]="deck" class="stroke-slate-300"></deck-edit-options>
                <deck-delete [deckId]="deck.id!" [deckName]="deck.name!" class="stroke-slate-300"></deck-delete>
            } @else if (deckComponent.isAuthed) {
                <deck-copy [deck]="deck" class="pt-1 pl-2 stroke-slate-300"></deck-copy>
                <deck-export [deck]="deck" class="stroke-slate-300"></deck-export>
            }
        </div>
    </div>
    
}